import type React from "react"
import { Link } from "react-router-dom"
import { Facebook, Linkedin, Mail, MapPin, Phone, Twitter } from "lucide-react"
import Image from "./Image"

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-16">
        <div className="grid lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <Image
              src="/images/2025-logo-invert.png"
              alt="MPV Multipurpose Vehicles"
              className="h-16 w-auto mb-6"
            />
            <p className="text-gray-400 mb-6 leading-relaxed">
              Australia's premier specialists in multipurpose vehicles and heavy machinery attachments. Over 20 years of
              innovation and excellence.
            </p>
            {false &&
            <div className="flex space-x-4">
              <button className="p-2 border border-gray-600 text-gray-400 hover:text-white hover:border-white rounded-lg transition-colors">
                <Facebook className="h-4 w-4" />
              </button>
              <button className="p-2 border border-gray-600 text-gray-400 hover:text-white hover:border-white rounded-lg transition-colors">
                <Twitter className="h-4 w-4" />
              </button>
              <button className="p-2 border border-gray-600 text-gray-400 hover:text-white hover:border-white rounded-lg transition-colors">
                <Linkedin className="h-4 w-4" />
              </button>
            </div>
            }
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/models" className="text-gray-400 hover:text-white transition-colors">
                  Models
                </Link>
              </li>
              <li>
                <Link to="/attachments" className="text-gray-400 hover:text-white transition-colors">
                  Attachments
                </Link>
              </li>
              <li>
                <Link to="/applications" className="text-gray-400 hover:text-white transition-colors">
                  Applications
                </Link>
              </li>
              <li>
                <Link to="/partners" className="text-gray-400 hover:text-white transition-colors">
                  Partners
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-white transition-colors">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-white transition-colors">
                  About Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Applications */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Applications</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/applications/municipal" className="text-gray-400 hover:text-white transition-colors">
                  Municipal Services
                </Link>
              </li>
              <li>
                <Link to="/applications/ground-care" className="text-gray-400 hover:text-white transition-colors">
                  Ground Care
                </Link>
              </li>
              <li>
                <Link to="/applications/road-maintenance" className="text-gray-400 hover:text-white transition-colors">
                  Road Maintenance
                </Link>
              </li>
              <li>
                <Link to="/applications/winter" className="text-gray-400 hover:text-white transition-colors">
                  Winter Operations
                </Link>
              </li>
              <li>
                <Link to="/applications/airport" className="text-gray-400 hover:text-white transition-colors">
                  Airport Operations
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact & Newsletter */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Get In Touch</h3>
            <div className="space-y-4 mb-6">
              <div className="flex items-start">
                <MapPin className="h-5 w-5 text-red-500 mr-3 mt-1" />
                <div className="text-gray-400">
                  <p>1F Industry Circuit</p>
                  <p>Kilsyth South, VIC 3137</p>
                  <p>Australia</p>
                </div>
              </div>
              <div className="flex items-center">
                <a href="tel:1800505791" className="flex items-center text-gray-400 hover:text-white transition-colors">
                  <Phone className="h-5 w-5 text-red-500 mr-3" />
                  <span className="text-gray-400">1800 505 791</span>
                </a>
              </div>
              <div className="flex items-center">
                <Mail className="h-5 w-5 text-red-500 mr-3" />
                <span className="text-gray-400">info@mpv-multihog.com.au</span>
              </div>
            </div>

            {false && 
            <div>
              <h4 className="font-semibold mb-3">Newsletter</h4>
              <div className="flex gap-2">
                <input
                  type="email"
                  placeholder="Your email"
                  className="flex-1 px-3 py-2 bg-gray-800 border border-gray-600 text-white placeholder:text-gray-400 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
                />
                <button className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg font-medium transition-colors">
                  Subscribe
                </button>
              </div>
            </div>
            }
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © {new Date().getFullYear()} MPV Multipurpose Vehicles. All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <Link to="#" className="text-gray-400 hover:text-white text-sm transition-colors">
                Privacy Policy
              </Link>
              <Link to="#" className="text-gray-400 hover:text-white text-sm transition-colors">
                Terms of Service
              </Link>
              <Link to="#" className="text-gray-400 hover:text-white text-sm transition-colors">
                Cookie Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
